import { Modal, Icon } from '@iwoca/orion';
import { connect, MapDispatchToProps } from 'react-redux';

import styles from './ErrorSaveApplicationModal.module.css';
import { CLOSE_MODAL } from '../../../containers/Modals/Modals.actions';
import { CloseSVG } from '../../../svgComponents';
import IwFormattedMessage from '../../IwFormattedMessage/IwFormattedMessage';
import messages from '../SaveApplication.messages';

interface ErrorSaveApplicationModalProps {
    isOpen: boolean;
    closeModal: () => void;
}

interface DispatchProps {
    closeModal: () => void;
}

const mapDispatchToProps: MapDispatchToProps<DispatchProps, unknown> = (
    dispatch
) => ({
    closeModal: () => dispatch({ type: CLOSE_MODAL })
});

const ErrorSaveApplicationModal: React.FC<ErrorSaveApplicationModalProps> = ({
    isOpen,
    closeModal
}) => {
    return (
        <Modal
            className={styles.errorSaveApplicationModal}
            onClose={closeModal}
            isOpen={isOpen}
            closeIcon={false}>
            <div className={styles.errorModalContainer}>
                <button
                    data-testid="close-error-save-modal"
                    className={styles.closeButton}
                    onClick={closeModal}
                    aria-label="Close">
                    <CloseSVG className="" />
                </button>

                <div className={styles.modalHeader}>
                    <Icon
                        icon="alertTriangle"
                        className={styles.alertTriangle}
                    />
                    <IwFormattedMessage
                        tagName="h1"
                        className={styles.modalTitle}
                        {...messages.errorHeading}
                    />
                </div>

                <div className={styles.divider}></div>
                <div className={styles.modalBody}>
                    <IwFormattedMessage
                        tagName="p"
                        {...messages.errorBody}
                        className={styles.modalDescription}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default connect(null, mapDispatchToProps)(ErrorSaveApplicationModal);
